import React, { useState } from "react";
import { Button, Checkbox, Col, Modal, Row } from "antd";
import { motion } from "framer-motion";
import { useSelector } from "react-redux"; // import "./OrgOnboarding.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import Leftarrow from "../../assets/images/Leftarrow.svg";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import './terms.scss';
// import termsAndConditions from '../../../src/assets/severnet-user-agreement.pdf'
import TermsViewer from "./termsViewer";
export default function TermsPage() {
  const navigate = useNavigate();

  const location = useLocation();
  const localData = useSelector((state) => state?.localStorage)
  const { partner } = localData
  const { state } = location;

  const [submitBtnStatus, SetSubmitBtnStatus] = useState(true);
  const [successModal, setSuccessModal] = useState(false);
  const [reviewModalVisible, setReviewModalVisible] = useState(false);

  const handleChange = (e) => {
    SetSubmitBtnStatus(!e.target.checked);
  };

  const handleCancel = () => {
    setReviewModalVisible(false);
  };

  const submitHandler = async () => {
    let submit = {
      userName: state?.formData?.userName,
      email: state?.formData?.email,
      phone: state?.formData?.phone,
      partnerName: partner,
      isActiveMember: state?.formData?.isActiveMember,
      name: state?.formData?.name,
      websiteLink: state?.formData?.websiteLink,
      typeId: state?.formData?.typeId,
      size: state?.formData?.size,
      addressInputs: [
        {
          street: state?.formData?.addressStreet,
          postalCode: state?.formData?.postcode,
        },
      ],
    };

    try {
      const response = await postRequest(userapiservice.signUpOrg(), submit);
      if (response) {
        setReviewModalVisible(false);
        setSuccessModal(true);
        sessionStorage.clear();
        setTimeout(() => {
          navigate(`/`);
        }, 10000);
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.response?.data?.message || 'Sorry, Something went wrong'} />)
    }
  };

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      // ✅ If no history, redirect to onboarding
      navigate("/onboarding", {
        state: {
          data: state?.formData,
        }
      });
    }
  };

  return (
    <motion.div
      className="background-container-terms"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="header">
        <div className="onBoarding-header">
          <img
            className="back-btn"
            src={Leftarrow}
            onClick={handleBack}
            alt="back button"
          />
          <h2>Apply to join "{state?.partnerLogo}"</h2>
        </div>
      </div>
      <div className="container">
        <div className="apply-header">
          <h2>Terms and Conditions</h2>
        </div>
        <div className="terms-text">

          {/* <iframe
            src={`${termsAndConditions}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            width="100%"
            height="100%"
            style={{ border: "none", borderRadius: "12px", padding:'12px' }}
            title="Terms and Conditions"
          /> */}
          <TermsViewer />
        </div>
        
        {/* <div className="terms-text">
          <div className="terms-content">
            <p>
              Please read these Terms and Conditions carefully before using our
              services.
            </p>
            <p>
              By accessing or using our services, you agree to be bound by these
              Terms and Conditions. If you do not agree with any part of these
              terms, do not access or use our services.
            </p>
            <br></br>
            <p>
              1. **Service Description:** Our services provide [brief
              description of services] to users [define users]. The services are
              subject to change or termination without prior notice.
            </p>
            <br></br>
            <p>
              2. **User Obligations:** Users must provide accurate information
              during registration. You are responsible for maintaining the
              confidentiality of your account and password. You agree to accept
              responsibility for all activities that occur under your account.
            </p>
            <br></br>
            <p>
              3. **Intellectual Property:** All content provided through our
              services, including text, graphics, logos, images, and software,
              is the property of [your company name] and protected by applicable
              intellectual property laws.
            </p>
            <br></br>
            <p>
              4. **Limitation of Liability:** We are not liable for any direct,
              indirect, incidental, special, or consequential damages arising
              from the use of our services.
            </p>
            <br></br>
            <p>
              5. **Privacy Policy:** Our Privacy Policy explains how we collect,
              use, and protect your personal information. By using our services,
              you consent to our Privacy Policy.
            </p>
            <br></br>
            <p>
              6. **Governing Law:** These Terms and Conditions shall be governed
              by and construed in accordance with the laws of [your
              jurisdiction].
            </p>
            <br></br>
            <p>
              By using our services, you acknowledge that you have read,
              understood, and agreed to these Terms and Conditions. If you do
              not agree with any part of these terms, you must refrain from
              using our services.
            </p>
            <br></br>
            <br></br>
            <br></br>
            <h4>
              <b>[Your company name]</b>
            </h4>
            <h4>
              <b>[Contact information]</b>
            </h4>
            <h4>
              <b>[Date]</b>
            </h4>
            <br></br>
            (Note: This is a generic sample and should be tailored to your
            specific needs. Consult with a legal professional to ensure accuracy
            and compliance with relevant laws.)
          </div>
        </div> */}
        <div className="check-submit">
          <div className="checkbox">
            <Checkbox onChange={handleChange}>
              <span className="checkbox-condition">
                Accept the terms and conditions
              </span>
            </Checkbox>
          </div>
        </div>
        <div className="submitbtn">
          <Button
            disabled={submitBtnStatus}
            onClick={() => setReviewModalVisible(true)}
            type="primary"
            htmlType="submit"
          >
            Review & Submit
          </Button>
        </div>
      </div>
      <Modal
        className="signup-confirm-modal"
        open={successModal}
        footer={null}
        // width={320}
        onCancel={() => setSuccessModal(false)}
      >
        <p className="signup-text">
          {/* Your Signup Process is completed and sent for approval. You
                        will be informed after approval... */}
          Thank you for signing up and once approved please check your email for
          your login details &#40; also check your spam folder &#41;
        </p>
      </Modal>

      <Modal
        open={reviewModalVisible}
        onCancel={handleCancel}
        // width={window.innerWidth >= 768 ? "850px" : null}
        footer={null}
        className="viewMicrositeModal"
      >
        <div className="approve-container">
          <div className="">
            <div className="ReviewInfoPopUp">
              <h2>Review your Information</h2>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol">Organisation type</div>
                <div className="ReviewInfoCol">{state?.nameType}</div>
              </div>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol">Are you an existing member</div>
                <div className="ReviewInfoCol">{state?.formData?.isActiveMember === true ? "Yes" : "No"}</div>
              </div>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol">Organisation name</div>
                <div className="ReviewInfoCol">{state?.formData?.name}</div>
              </div>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol">Address</div>
                <div className="ReviewInfoCol">{state?.formData?.addressStreet}</div>
              </div>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol">Postal code</div>
                <div className="ReviewInfoCol">{state?.formData?.postcode}</div>
              </div>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol"> Organisation size</div>
                <div className="ReviewInfoCol">
                  {state?.formData?.size === "MICRO" ? "Micro 0-9"
                    : state?.formData?.size === "SMALL" ? "Small 10-49"
                      : state?.formData?.size === "MEDIUM" ? "Medium 50-249"
                        : state?.formData?.size === "LARGE" ? "Large 249+"
                          : ""}
                </div>
              </div>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol">Full name</div>
                <div className="ReviewInfoCol">{state?.formData?.userName}</div>
              </div>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol">Email</div>
                <div className="ReviewInfoCol">{state?.formData?.email}</div>
              </div>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol">Phone number</div>
                <div className="ReviewInfoCol">{state?.formData?.phone}</div>
              </div>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol">Organisation website</div>
                <div className="ReviewInfoCol">{state?.formData?.websiteLink}</div>
              </div>
              <div className="ReviewInfoRow">
                <div className="ReviewInfoCol"></div>
                <div className="ReviewInfoCol">
                  <Button
                    onClick={() => navigate("/onboarding", {
                      state: {
                        data: state?.formData,
                      }
                    })}
                    // type="default"
                    // htmlType="submit"
                    className="editbtn"
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => submitHandler()}
                    type="primary"
                    htmlType="submit"
                    className="greenBtn"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>



          </div>
        </div>
      </Modal>
    </motion.div>
  );
}
